import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  title: 'Countdown Teaser',
  name: 'countdownTeaser',
  type: 'object',
  fields: [
    defineField({
      title: 'Desktop BG',
      name: 'bgDesktop',
      type: 'image',
      description:
        'Object must be left aligned covering the maximum of 50% of the image width',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Mobile BG',
      name: 'bgMobile',
      type: 'image',
      options: {
        hotspot: true,
      },
      description:
        'Object must be bottom aligned covering the maximum of 50% of the image height',
    }),
    defineField({
      title: 'Pre Title (h3)',
      name: 'preTitle',
      type: 'text',
      rows: 3,
    }),
    defineField({
      title: 'Title (h2)',
      name: 'title',
      type: 'text',
      rows: 3,
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: strongEmLink,
    }),
    defineField({
      title: 'Countdown Date',
      name: 'countdownDate',
      type: 'datetime',
      options: {
        dateFormat: 'YYYY-MM-DD',
        timeFormat: 'HH:mm',
        // timeStep: 60,
        // calendarTodayLabel: 'Today'
      },
    }),
    defineField({
      title: 'Show countdown',
      name: 'showCounter',
      type: 'boolean',
      initialValue: true,
      description:
        'Select this option if you want to have counter ticking on the page.',
    }),
    defineField({
      title: 'Mailing List Tag',
      name: 'mailingListTag',
      type: 'string',
    }),
    defineField({
      title: 'Mailing List Audience ID',
      name: 'mailingListAudienceId',
      type: 'string',
    }),
    defineField({
      title: 'Mailing List Info',
      name: 'mlInfo',
      type: 'text',
      rows: 3,
    }),
  ],
  preview: {
    select: {
      title: 'title',
      subtitle: 'countdownDate',
    },
    prepare({ title, subtitle }) {
      return {
        title,
        subtitle,
      }
    },
  },
})